import { Component } from "@angular/core";

@Component({
    selector: "soporte",
    templateUrl: "./soporte.component.html"
})

export class SoporteComponent {
    title = "Centro de Atención a Usuarios";
    p1 = "Correo electrónico: ";
    correo = "cexveg@mapa.es";
    p2 = "Teléfonos: ";
    tlf1 = "  91-322-51-41";
    tlf2 = "  91-322-51-03";
}
